import { render, staticRenderFns } from "./MenubarSub.vue?vue&type=template&id=a6dcf4f2&"
import script from "./MenubarSub.vue?vue&type=script&lang=js&"
export * from "./MenubarSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports